import { LabelType } from 'generated/graphql';
import { FeedbackLabelType } from 'v2/core/entities/feedback';

export const getEdgeLabelTypeFromFeedbackLabelType = (
  feedbackLabelType: FeedbackLabelType,
) => {
  switch (feedbackLabelType) {
    case FeedbackLabelType.Entity:
      return LabelType.Aspect;
    case FeedbackLabelType.Reason:
      return LabelType.Reason;
    case FeedbackLabelType.Sentiment:
      return LabelType.Sentiment;
    case FeedbackLabelType.L1:
      return LabelType.L1;
    default:
      return null;
  }
};
